// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"451":"edd24e1d10b95f01","517":"12e62850c32191f2"}[chunkId] + ".js";
};